import './ProgressBar.css';

function ProgressBar({now, base}) {
  return <div className="ProgressBar">
      <label className="ProgressBar-label">{now} / {base}</label>
      <progress className="ProgressBar-bar" value={now} max={base}>{now} / {base}</progress>
    </div>
}

export default ProgressBar